'use client';

import { useEffect, useRef } from 'react';

import { trackEvent } from '@/lib/analytics/gtm';

const MILESTONES = [25, 50, 75, 90];

export function ScrollDepthTracker({ feature }: { feature: string }) {
  const fired = useRef(new Set<number>());

  useEffect(() => {
    const firedSet = fired.current;
    let rafId: number;

    const handleScroll = () => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        const scrolled = window.scrollY + window.innerHeight;
        const total = document.documentElement.scrollHeight;
        const pct = (scrolled / total) * 100;

        for (const milestone of MILESTONES) {
          if (pct >= milestone && !firedSet.has(milestone)) {
            firedSet.add(milestone);
            trackEvent({ feature, action: `scroll_${milestone}` });
          }
        }
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      cancelAnimationFrame(rafId);
    };
  }, [feature]);

  return null;
}
